import type { Driver } from '../types/domain';
import { images } from './images';

export const drivers: Driver[] = [
  {
    id: 'd1',
    name: 'মোঃ করিম শেখ',
    father: 'মৃত আব্দুল জব্বার শেখ',
    license: 'BRTA-1234567',
    licenseType: 'পেশাদার — হালকা (থ্রি-হুইলার)',
    nid: '1985123456789',
    mobile: '01711-111111',
    dob: '০৫ মে ১৯৮৫',
    issueDate: '১৬ মার্চ ২০২২',
    expiry: '১৫ মার্চ ২০২৭',
    expiryTone: 'green',
    status: 'সক্রিয়',
    address: 'বাড়ি ১২, রোড ৪, সেকশন ৬, মিরপুর, ঢাকা-১২১৬',
    bloodGroup: 'B+',
    qrId: 'DRV-000001',
    photo: images.driver1,
    brtaVerified: true
  },
  {
    id: 'd2',
    name: 'মোঃ সেলিম উদ্দিন',
    father: 'মোঃ নাসির উদ্দিন',
    license: 'BRTA-7654321',
    licenseType: 'পেশাদার — হালকা (থ্রি-হুইলার)',
    nid: '1990112345678',
    mobile: '01822-222222',
    dob: '১২ জানুয়ারি ১৯৯০',
    issueDate: '১১ জানুয়ারি ২০২৩',
    expiry: '১০ জানুয়ারি ২০২৮',
    expiryTone: 'green',
    status: 'সক্রিয়',
    address: 'বাসা ৪৫, পল্লবী, মিরপুর-১১, ঢাকা-১২১৬',
    bloodGroup: 'O+',
    qrId: 'DRV-000002',
    photo: images.driver2,
    brtaVerified: true
  },
  {
    id: 'd3',
    name: 'মোঃ আক্তার হোসেন',
    father: 'মোঃ মোজাম্মেল হোসেন',
    license: 'BRTA-9876543',
    licenseType: 'পেশাদার — হালকা (থ্রি-হুইলার)',
    nid: '1989012345678',
    mobile: '01933-333333',
    dob: '০১ ফেব্রুয়ারি ১৯৮৯',
    issueDate: '২১ আগস্ট ২০২২',
    expiry: '২০ আগস্ট ২০২৭',
    expiryTone: 'green',
    status: 'সক্রিয়',
    address: 'বাড়ি ৭, ব্লক-সি, মিরপুর-২, ঢাকা-১২১৬',
    bloodGroup: 'A+',
    qrId: 'DRV-000003',
    photo: images.driver3,
    brtaVerified: true
  },
  {
    id: 'd4',
    name: 'মোঃ জসিম মিয়া',
    father: 'মোঃ সোবহান মিয়া',
    license: 'BRTA-4455667',
    licenseType: 'পেশাদার — হালকা (থ্রি-হুইলার)',
    nid: '1987223344556',
    mobile: '01715-404040',
    dob: '১৮ জুলাই ১৯৮৭',
    issueDate: '০৩ এপ্রিল ২০২৩',
    expiry: '০২ এপ্রিল ২০২৮',
    expiryTone: 'green',
    status: 'সক্রিয়',
    address: 'বাড্ডা, গুলশান, ঢাকা-১২১২',
    bloodGroup: 'AB+',
    qrId: 'DRV-000004',
    brtaVerified: true
  },
  {
    id: 'd5',
    name: 'মোঃ রফিকুল ইসলাম',
    father: 'মোঃ আব্দুর রশিদ',
    license: 'BRTA-3322110',
    licenseType: 'পেশাদার — হালকা (থ্রি-হুইলার)',
    nid: '1992334455667',
    mobile: '01913-505050',
    dob: '০৯ সেপ্টেম্বর ১৯৯২',
    issueDate: '১৫ জুন ২০২১',
    expiry: '১৪ ডিসেম্বর ২০২৬',
    expiryTone: 'orange',
    status: 'সক্রিয়',
    address: 'মহাখালী, ঢাকা-১২১২',
    bloodGroup: 'O-',
    qrId: 'DRV-000005',
    brtaVerified: true
  },
  {
    id: 'd6',
    name: 'মোঃ শাহ আলম',
    father: 'মোঃ আব্দুল হাই',
    license: 'BRTA-5566778',
    licenseType: 'পেশাদার — হালকা (থ্রি-হুইলার)',
    nid: '1984556677889',
    mobile: '01817-606060',
    dob: '২২ মার্চ ১৯৮৪',
    issueDate: '২০ নভেম্বর ২০২১',
    expiry: '১৯ নভেম্বর ২০২৬',
    expiryTone: 'orange',
    status: 'সক্রিয়',
    address: 'তেজগাঁও শিল্প এলাকা, ঢাকা-১২০৮',
    bloodGroup: 'B+',
    qrId: 'DRV-000006',
    brtaVerified: true
  },
  {
    id: 'd7',
    name: 'মোঃ নুরুল আমিন',
    father: 'মৃত আলী আকবর',
    license: 'BRTA-1122334',
    licenseType: 'পেশাদার — হালকা (থ্রি-হুইলার)',
    nid: '1980667788990',
    mobile: '01611-707070',
    dob: '১৪ জানুয়ারি ১৯৮০',
    issueDate: '১০ ফেব্রুয়ারি ২০১৯',
    expiry: '০৯ ফেব্রুয়ারি ২০২৬',
    expiryTone: 'red',
    status: 'মেয়াদোত্তীর্ণ',
    address: 'শাহবাগ, রমনা, ঢাকা-১০০০',
    bloodGroup: 'A-',
    qrId: 'DRV-000007',
    brtaVerified: false
  },
  {
    id: 'd8',
    name: 'মোঃ আলমগীর হোসেন',
    father: 'মোঃ ইদ্রিস আলী',
    license: 'BRTA-6677889',
    licenseType: 'পেশাদার — হালকা (থ্রি-হুইলার)',
    nid: '1991778899001',
    mobile: '01755-808080',
    dob: '৩০ অক্টোবর ১৯৯১',
    issueDate: '০৮ মে ২০২৪',
    expiry: '০৭ মে ২০২৯',
    expiryTone: 'green',
    status: 'সক্রিয়',
    address: 'কাফরুল, মিরপুর, ঢাকা-১২০৬',
    bloodGroup: 'O+',
    qrId: 'DRV-000008',
    brtaVerified: true
  },
  {
    id: 'd9',
    name: 'মোঃ বাবুল মিয়া',
    father: 'মোঃ সিরাজ মিয়া',
    license: 'BRTA-2233445',
    licenseType: 'পেশাদার — হালকা (থ্রি-হুইলার)',
    nid: '1986889900112',
    mobile: '01944-909090',
    dob: '০৬ জুন ১৯৮৬',
    issueDate: '১৯ আগস্ট ২০২৩',
    expiry: '১৮ আগস্ট ২০২৮',
    expiryTone: 'green',
    status: 'সক্রিয়',
    address: 'লালবাগ, ঢাকা-১২১১',
    bloodGroup: 'B-',
    qrId: 'DRV-000009',
    brtaVerified: true
  },
  {
    id: 'd10',
    name: 'মোঃ ফারুক আহমেদ',
    father: 'মোঃ নওশের আলী',
    license: 'BRTA-8899001',
    licenseType: 'পেশাদার — হালকা (থ্রি-হুইলার)',
    nid: '1988990011223',
    mobile: '01799-121212',
    dob: '১১ ডিসেম্বর ১৯৮৮',
    issueDate: '২৫ জানুয়ারি ২০২৪',
    expiry: '২৪ জানুয়ারি ২০২৯',
    expiryTone: 'green',
    status: 'সক্রিয়',
    address: 'ওয়ারী, ঢাকা-১২০৩',
    bloodGroup: 'A+',
    qrId: 'DRV-000010',
    brtaVerified: true
  },
  {
    id: 'd11',
    name: 'মোঃ মিজানুর রহমান',
    father: 'মোঃ লুৎফর রহমান',
    license: 'BRTA-5544332',
    licenseType: 'পেশাদার — হালকা (থ্রি-হুইলার)',
    nid: '1993112233445',
    mobile: '01822-343434',
    dob: '০২ এপ্রিল ১৯৯৩',
    issueDate: '১২ সেপ্টেম্বর ২০২৪',
    expiry: '১১ সেপ্টেম্বর ২০২৯',
    expiryTone: 'green',
    status: 'নিষ্ক্রিয়',
    address: 'উত্তরা সেক্টর ১০, ঢাকা-১২৩০',
    bloodGroup: 'O+',
    qrId: 'DRV-000011',
    brtaVerified: true
  }
];

export function getDriver(id: string): Driver | undefined {
  return drivers.find((d) => d.id === id);
}
